import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { Checkbox } from 'semantic-ui-react';

import Modal from "../../ui/Modals/ModalWindow";
import TemplateItem from "../../ui/TemplateItem/TemplateItem";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";
import "./TemplateInfo.scss";

import {
  getTemplateInfoAsync,
  changeTemplateVisibilityAsync,
  deleteTemplateAsync,
} from "../../../redux/actions/templateInfo";

import { openDeleteTemplateModal, closeDeleteTemplateModal } from "../../../redux/actions/ui";

const mapStateToProps = state => ({
  ...state.templateInfo,
  deleteTemplateModal: state.ui.deleteTemplateModal,
});

const mapDispatchToProps = dispatch => ({
  onGoBack: () => dispatch(push('/templates')),
  getTemplateInfo: templateId => dispatch(getTemplateInfoAsync(templateId)),
  onEditTemplate: templateId => dispatch(push(`/edit-template/${templateId}`)),
  onChangeTemplateVisibility: (status, templateId) => dispatch(changeTemplateVisibilityAsync(status, templateId)),
  onDeleteTemplate: templateId => dispatch(deleteTemplateAsync(templateId)),
  openDeleteModal: () => dispatch(openDeleteTemplateModal()),
  closeDeleteModal: () => dispatch(closeDeleteTemplateModal()),
});

class TemplateInfo extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    template: PropTypes.object.isRequired,
    deleteTemplateModal: PropTypes.object.isRequired,
    openDeleteModal: PropTypes.func.isRequired,
    closeDeleteModal: PropTypes.func.isRequired,
    onGoBack: PropTypes.func.isRequired,
    getTemplateInfo: PropTypes.func.isRequired,
    onEditTemplate: PropTypes.func.isRequired,
    onChangeTemplateVisibility: PropTypes.func.isRequired,
    onDeleteTemplate: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { getTemplateInfo } = this.props;
    const templateId= this.props.match.params.templateId;
    getTemplateInfo(templateId);
  }

  render() {
    const {
      ready,
      loading,
      template,
      onGoBack,
      onEditTemplate,
      onChangeTemplateVisibility,
      onDeleteTemplate,
      deleteTemplateModal,
      openDeleteModal,
      closeDeleteModal,
    } = this.props;

    return (
      <div className="page-wrapper">
         <Modal
          heading="Вы уверены, что хотите удалить шаблон? Восстановить его будет невозможно"
          confirmText="Отмена"
          cancelText="Удалить"
          modal={deleteTemplateModal}
          onSubmit={() => closeDeleteModal()}
          onCancel={() => onDeleteTemplate(template.id)}
         />
        {ready ? (
          <React.Fragment>
            <div className="page-header">
              <button type="button" className="btn btn-back" onClick={() => onGoBack()}>
                <i aria-hidden="true" className="back-icon icon" />
                <span>Назад</span>
              </button>
            </div>
          
            <div className="page-content forms">
              <div className="poll-header">
                <div className="poll-btns">
                  <button
                    type="button"
                    className="btn btn-green edit-size"
                    onClick={() => onEditTemplate(template.id)}
                  >
                    Редактировать
                  </button>
                  {/* Кнопка "Удалить" есть только у шаблонов, у которых нет свойства "По умолчанию" */}
                  {!template.is_default ? (
                    <button
                      type="button"
                      className="btn btn-red del-size"
                      onClick={() => openDeleteModal()}
                    >
                      Удалить
                    </button> 
                  ) : false}
                </div>
                {/* Кнопка "Показать/Скрыть" есть только у шаблонов, у которых нет свойства "По умолчанию" */}
                {!template.is_default ? (
                  <div className="checkboxes-wrap">
                    <Checkbox
                      label='Скрывать шаблон'
                      checked={!template.is_enabled}
                      onChange={() => onChangeTemplateVisibility(!template.is_enabled, template.id)}
                    />
                  </div>
                ) : false}
              </div>
              <div className="title-wrap">
                <h1 className="page-title template-title">{template.name}</h1>
                {template.is_default ? (
                  <div className="by-default">По умолчанию</div>
                ) : false}
              </div>
              <div className="templates-wrapper">
                <TemplateItem
                  key={`${template.id}_${1}`}
                  template={template}
                  type={'trapezoidal'}
                />
                <TemplateItem
                  key={`${template.id}_${2}`}
                  template={template}
                  type={'round'}
                />
                <TemplateItem
                  key={`${template.id}_${3}`}
                  template={template}
                  type={'square'}
                />
              </div>
            </div>
          </React.Fragment>
        ) : false}
        {loading ? (<Spinner />) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(TemplateInfo));
